import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authApi, formatApiError } from "../../lib/authApi";
import { AuthShell, Field, PrimaryBtn, SmallLink, Notice } from "../../components/auth/AuthShell";
import SocialButtons from "../../components/auth/SocialButtons";

const SignupPage = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [callsign, setCallsign] = useState("");
  const [err, setErr] = useState(null);
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(null); setBusy(true);
    if (pw !== pw2) { setErr("Passwords do not match."); setBusy(false); return; }
    if (pw.length < 8) { setErr("Password must be at least 8 characters."); setBusy(false); return; }
    try {
      const { data } = await authApi.signup({ email, password: pw, password_confirm: pw2, callsign: callsign.trim() });
      setDone(data.message || "Check your inbox to verify your email.");
    } catch (e) {
      setErr(formatApiError(e?.response?.data?.detail) || "Signup failed.");
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <AuthShell title="Verify your inbox" lead="We sent a verification link. Click it to activate your Archive account.">
        <Notice kind="success" data-testid="signup-success">{done}</Notice>
        <PrimaryBtn onClick={() => nav("/auth/login")} type="button" data-testid="signup-go-login">
          GO TO SIGN IN
        </PrimaryBtn>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      title="Create your operative file"
      lead="Email + password. We'll send a verification link. Your account stays inactive until you verify."
      footer={<>Already a member? <SmallLink to="/auth/login" data-testid="signup-link-login">Sign in</SmallLink></>}
    >
      {err && <Notice kind="error" data-testid="signup-error">{err}</Notice>}
      <SocialButtons disabled={busy} />
      <form onSubmit={onSubmit} data-testid="signup-form">
        <Field label="EMAIL" type="email" value={email} onChange={setEmail}
               required autoComplete="email" autoFocus
               data-testid="signup-email" name="email" />
        <Field label="PASSWORD" type="password" value={pw} onChange={setPw}
               required autoComplete="new-password"
               data-testid="signup-password" name="password" />
        <Field label="CONFIRM PASSWORD" type="password" value={pw2} onChange={setPw2}
               required autoComplete="new-password"
               data-testid="signup-password-confirm" name="password_confirm" />
        <Field label="CALLSIGN (OPTIONAL)" type="text" value={callsign}
               onChange={(v) => setCallsign(v.toUpperCase())}
               autoComplete="off" maxLength={24}
               placeholder="e.g. RAVEN, WATCHTOWER, CIPHER-7"
               data-testid="signup-callsign" name="callsign" />
        <p className="font-mono text-[9px] text-[#5A554C] -mt-2 mb-3">
          Oracle addresses you by callsign — never by name. Leave blank and The
          Archive assigns one. Changeable later in Archive Command.
        </p>
        <PrimaryBtn disabled={busy} data-testid="signup-submit">
          {busy ? "PROCESSING…" : "CREATE ACCOUNT"}
        </PrimaryBtn>
      </form>
    </AuthShell>
  );
};

export default SignupPage;
